import React, { useMemo, useState } from 'react';

import { array, string } from 'yup';

import { FormSection } from 'src/app/components/lib/form';
import { Input } from 'src/app/components/lib/input';
import { Modal } from 'src/app/components/lib/modal';

type SendTestEmailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSendClick: (sendTo: string) => void;
};

const yupEmailSchemaNew = array().of(string().trim().email().required()).min(1);

export function SendTestEmailModal({ onSendClick, isOpen, onClose }: SendTestEmailModalProps) {
  const [sendTo, setSendTo] = useState('');

  const isValidEmail = useMemo(() => {
    const emails = sendTo?.split(';') ?? [];
    return yupEmailSchemaNew.isValidSync(emails);
  }, [sendTo]);

  const label = 'Provide one or more email addresses separated by semicolons:';

  return (
    <Modal
      Content={
        <FormSection>
          <Input label={label} labelPlacement='top' value={sendTo} onChange={(e) => setSendTo(e.target.value)} />
        </FormSection>
      }
      open={isOpen}
      primaryActions={[
        {
          label: 'Send',
          onClick: () => onSendClick(sendTo),
          disabled: !isValidEmail,
        },
      ]}
      title='Send preview'
      onClose={onClose}
    />
  );
}
